import { Pipe, PipeTransform, EventEmitter } from '@angular/core';

/**
 * Generated class for the ItemLimitPipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
    name: 'itemLimit',
    pure: true
})
export class ItemLimitPipe implements PipeTransform
{
    /**
     * Takes a value and makes it lowercase.
     */
    transform(value: any[], batchNumber: number, batchCount: number, onCompleted: EventEmitter<any>)
    {
        if (!value)
        {
            return;
        }

        // get the maximum safe number of items
        let limit = Math.min(value.length, (batchNumber + 1) * batchCount);

        let returnedItems = value.slice(0, limit);

        // if the datasource has been exhausted then trigger the event
        if (returnedItems.length === value.length && onCompleted !== null)
        {
            onCompleted.emit();
        }

        return returnedItems;
    }

}
